import { render } from "./DashboardSideBarMenuMobile.vue?vue&type=template&id=ca50a1b0&scoped=true"
import script from "./DashboardSideBarMenuMobile.vue?vue&type=script&lang=js"
export * from "./DashboardSideBarMenuMobile.vue?vue&type=script&lang=js"

import "./DashboardSideBarMenuMobile.vue?vue&type=style&index=0&id=ca50a1b0&scoped=true&lang=css"

import exportComponent from "/home/runner/work/multiCotizadorCR/multiCotizadorCR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca50a1b0"]])

export default __exports__